export const MuiIconButtonOverride = {
  styleOverrides: {
    root: {
      borderRadius: '100%',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
      color: '#2222B3',
      backgroundColor: '#FFFFFF',
    },
    contained: {
      background: '#2222B3',
      color: 'white',
    },
  },
};
